import { SVGProps } from '@components/Icon/types';

export const Certification = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.5, 2)">
      <path
        d="M20.3129 15.8741C20.6704 15.8741 20.9511 16.1465 20.9511 16.4985V19.3746C20.951 19.5999 20.8263 19.8062 20.6339 19.9132C20.5243 19.9774 20.4147 19.9989 20.3129 19.9989C20.2291 19.9989 20.1003 19.9829 19.9938 19.9132V19.9151L17.8108 18.6626L15.6278 19.9151L15.624 19.917C15.4491 20.0118 15.1989 20.0428 14.9925 19.9161C14.7971 19.8099 14.6706 19.602 14.6705 19.3746V16.4985C14.6705 16.1465 14.9512 15.8741 15.3087 15.8741C15.6661 15.8742 15.9459 16.1465 15.946 16.4985V18.2916L17.4812 17.4157C17.6793 17.2867 17.9423 17.2867 18.1405 17.4157L19.6756 18.2916V16.4985C19.6757 16.1465 19.9555 15.8742 20.3129 15.8741Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8108 9.54744C19.5721 9.54744 21 10.9506 21 12.6816C21 14.4125 19.5721 15.8157 17.8108 15.8157C16.0495 15.8157 14.6216 14.4125 14.6216 12.6816C14.6216 10.9506 16.0495 9.54744 17.8108 9.54744ZM17.8108 10.7048C16.6998 10.7048 15.7994 11.5897 15.7994 12.6816C15.7994 13.7734 16.6998 14.6583 17.8108 14.6583C18.9218 14.6583 19.8223 13.7734 19.8223 12.6816C19.8223 11.5897 18.9218 10.7048 17.8108 10.7048Z"
        fill={fill}
      />
      <path
        d="M11.8004 9.35155C12.216 9.35156 12.5611 9.67376 12.5613 10.0805C12.5613 10.4873 12.2161 10.8094 11.8004 10.8094H4.44072C4.02501 10.8094 3.67984 10.4873 3.67984 10.0805C3.67999 9.67375 4.0251 9.35155 4.44072 9.35155H11.8004Z"
        fill={fill}
      />
      <path
        d="M15.4802 6.42931C15.8959 6.42932 16.241 6.7515 16.2411 7.15822C16.2411 7.56505 15.8959 7.88712 15.4802 7.88713H4.44072C4.02501 7.88713 3.67984 7.56506 3.67984 7.15822C3.67997 6.75149 4.02509 6.42931 4.44072 6.42931H15.4802Z"
        fill={fill}
      />
      <path
        d="M15.4802 3.50707C15.8959 3.50708 16.241 3.82925 16.2411 4.23598C16.2411 4.64281 15.8959 4.96488 15.4802 4.96489H4.44072C4.02501 4.96489 3.67984 4.64282 3.67984 4.23598C3.67996 3.82924 4.02508 3.50707 4.44072 3.50707H15.4802Z"
        fill={fill}
      />
      <path
        d="M17.9335 0C19.0266 1.25455e-05 19.921 0.846162 19.921 1.89856V7.38895C19.921 7.80192 19.5803 8.1367 19.1601 8.1367C18.7399 8.1367 18.3992 7.80192 18.3992 7.38895V1.89856C18.3992 1.65984 18.1952 1.45878 17.9335 1.45877H1.9875C1.72577 1.45877 1.52177 1.65983 1.52177 1.89856V12.4188C1.52193 12.6574 1.72587 12.8586 1.9875 12.8586H12.4118C12.8214 12.8586 13.1535 13.185 13.1535 13.5875C13.1535 13.9901 12.8214 14.3164 12.4118 14.3164H1.9875C0.894444 14.3164 0.0001588 13.4711 0 12.4188V1.89856C0 0.846155 0.894347 0 1.9875 0H17.9335Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'certification';
